"use client";

import { motion } from "framer-motion";

const logos = [
  "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhR7neYrbe_M6nW_k1_HDfJrqKHOAss8Vl_ItabIKOELM541KB8ctDUlq2AsSuXKuu0YLUGwjew9Nj9TMQrS9zG3nZnMzbDvkdG4b8cM5xy1FVRArCBE-MyLqK3uPItlK7KZvlMNErvuE1Y_j_7n10DhH448g2FHyGvwirjjYyE7W00KintIAT-_gH8Wjks/w577-h577/Untitled%20design.png=w635-h635-p-k-no-nu",
  "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhy35Fr0lzO0vLkCSyOz66HfsH5aDwEersimgWZRBeUmmWxGO8Wh-epN5qj7EsfrhHwhmPqBNPLvzwDtEz7E0XVaKKtX_jfzNwxsvHk3x7UiRDb4s35PyW60WsrIjBLr6b5zT2FXf1sNZhSferqHKhdvR5n-KBwq6B7rNdauxqkMSB0tJ8x9ul2KsMeJEBi/w571-h286/Untitled%20design%20(2).png=w628-h315-p-k-no-nu",
  "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhNHgtR3-xN5wkwZ00YCoxwXjl73xwkte2WvWat8Smz0hZSdOYEgpH54cdWEQZYdPLPIHhrXvxCX5LfW5iuijw0jch94L0f2njJ5si75reD-H0nyG33EaDx9tM077iCEzQ9QM181NQTAkJhvYUcuiLTuN7mfw8vxhrwXN9XA7siLbDvTLzdvMh29fGAMqXP/w547-h547/Untitled%20design%20(3).png=w602-h602-p-k-no-nu",
  "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg6e3NbOBAVtJ5LpUevtWoNY3ao-iaVxhsvy4Hs2CVEjjftfzsUanjbU31JP0XOFQcnzrVf6XmByx148KrAr9WMKQ7wbzhgETINlhMSsXnUUWNor0CPXuSzuHIp4uA4hPI5rAQNJjmydcTaYRpL9ulB8C0kJ-IrRT5gZE7ejPcVM0t_UaGveFFV_U0Dc6zP/w537-h436/Untitled%20design%20(4).png=w591-h480-p-k-no-nu",
  "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgUWeOeZIoI0YPBNRF__MDaD8Yv7brH64-czQb1sF12zvNSFRC_iFR5K6WB-gKPgMp6IBpvPluQSejx3_EgyjmtJN835_qbDRDKvganUI4NDJSp5TwlKFaWfy32LEGDf7OdGNAfcKMEtI2RxmeY8axTIWQgSU5SwhyXI47b1oZ7baUWv0fs9SYf6tdVlM5E/w596-h216/Untitled%20design%20(5).png=w656-h238-p-k-no-nu",
];

export default function BrandsStrip() {
  return (
    <section className="bg-blue-600 py-20 relative overflow-hidden">

      <div className="absolute inset-0 bg-white/10 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="
            flex flex-col
            md:flex-row
            items-center
            justify-center
            gap-6 md:gap-16
          "
        >

          {logos.map((logo, i) => (
            <motion.div
              key={i}
              whileHover={{ scale: 1.1 }}
              className="
                flex items-center justify-center
                py-4 px-6
                rounded-2xl
              "
            >
              <img
                src={logo}
                alt="logo"
                className="h-[190px] md:h-32 object-contain"
              />
            </motion.div>
          ))}

        </motion.div>

      </div>
    </section>
  );
}